/* The Seven Lucky Gods: <tslg-treasure> plays the lacquer treasure's 3.2 s opening once, poster first.
   Used by sections/tslg-treasure.liquid (home page, gifts collection) and snippets/tslg-reveal-mini.liquid (empty cart).
   Reduced motion, blocked autoplay or no JavaScript: the open still stays and nothing moves unless a visitor asks. */
(() => {
  if (customElements.get('tslg-treasure')) return;

  customElements.define('tslg-treasure', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.video = this.querySelector('.tslg-tr__video');
      this.btn = this.querySelector('.tslg-tr__replay');
      if (!this.video || !this.video.dataset.src) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.btn) {
        this.btn.addEventListener('click', () => this.play(true));
        this.video.addEventListener('ended', () => this.showButton(this.btn.dataset.labelAgain));
      }
      if (this.dataset.autoplay !== 'true' || reduce) {
        this.showButton(this.btn && this.btn.dataset.labelFirst);
        return;
      }
      this.classList.add('is-motion'); // closed poster first, so the opening reads as an opening
      this.io = new IntersectionObserver((entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          this.io.disconnect();
          this.play(false);
        }
      }, { threshold: 0.6 });
      this.io.observe(this.querySelector('.tslg-tr__stage') || this);
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      this.ready = false;
    }

    showButton(label) {
      if (!this.btn || !label) return;
      this.btn.querySelector('span').textContent = label;
      this.btn.setAttribute('aria-label', label);
      this.btn.classList.remove('is-off');
    }

    play(asked) {
      const v = this.video;
      if (!v.getAttribute('src')) v.src = v.dataset.src;
      v.currentTime = 0;
      if (!asked && this.btn) this.btn.classList.add('is-off'); // a pressed button stays put, so keyboard focus is never lost
      const p = v.play();
      if (p && p.catch) {
        p.then(() => this.classList.add('is-motion')).catch(() => {
          this.classList.remove('is-motion');
          this.showButton(this.btn && this.btn.dataset.labelFirst);
        });
      } else {
        this.classList.add('is-motion');
      }
    }
  });
})();
